import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_QUESTIONS_ERROR, UPDATE_QUESTIONS_START, UPDATE_QUESTIONS_SUCCESS} from "../../types";

export function* update({payload}) {
    try {
        const url = `/questions/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_QUESTIONS_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-questions'));
    } catch (error) {
        yield put({type: UPDATE_QUESTIONS_ERROR, error});
    }
}

export default function* update_questions() {
    yield takeLatest(UPDATE_QUESTIONS_START, update);
}